// Same rule as the root reducer: import saga listeners from each module's deep `src/store` path,
// never from the module barrel. The barrels also re-export full page components (with no
// `sideEffects: false`), which would drag those pages into the boot entry.
import { CostsSagasListener } from '@cobliteam/costs/src/store';
import { DeviceConfigurationSagasListener } from '@cobliteam/device-configuration/src/store';
import { PastMaintenancesSagasListener, RegisterMaintenanceSagasListener, UpcomingMaintenancesSagasListener } from '@cobliteam/maintenance/src/store';
import { RoutesSagasListener } from '@cobliteam/routing/src/store/Routes/sagas';
import { NewRoutingSagasListener } from '@cobliteam/routing/src/store/Routing/sagas';
import { VehicleSagasListener } from '@cobliteam/store';
import { RouteHistorySagasListener, TrackingSagasListener } from '@cobliteam/tracking/src/store';
import type { SagaMiddleware } from 'redux-saga';
import { AlarmsSagasListener } from './Alarms/sagas';
import { DevicesSagasListener } from './Devices/sagas';
import { DisablerSagasListener } from './Disabler/sagas';
import { DriversSagasListener } from './Drivers/sagas';
import { FleetSagasListener } from './Fleet/sagas';
import { GeocodeSagasListener } from './Geocode/sagas';
import { GeofenceFormSagasListener } from './GeofenceForm/sagas';
import { GeofenceSagasListener } from './Geofences/sagas';
import { InvitesSagasListener } from './Invites/sagas';
import { PasswordSagasListener } from './Password/sagas';
import { ReportsSagasListener } from './Performance/Reports/sagas';
import { UserSagasListener } from './Users/sagas';
import { VehiclePopupSagasListener } from './VehiclePopup/sagas';
import { VehiclesTabSagasListener } from './VehiclesTab/sagas';

const arrayOfSagas = [
  DriversSagasListener,
  DisablerSagasListener,
  GeofenceSagasListener,
  VehicleSagasListener,
  VehiclesTabSagasListener,
  FleetSagasListener,
  GeocodeSagasListener,
  CostsSagasListener,
  ReportsSagasListener,
  DevicesSagasListener,
  GeofenceFormSagasListener,
  UserSagasListener,
  InvitesSagasListener,
  AlarmsSagasListener,
  PastMaintenancesSagasListener,
  UpcomingMaintenancesSagasListener,
  RegisterMaintenanceSagasListener,
  PasswordSagasListener,
  VehiclePopupSagasListener,
  TrackingSagasListener,
  RouteHistorySagasListener,
  NewRoutingSagasListener,
  RoutesSagasListener,
  DeviceConfigurationSagasListener,
];

const SagaMiddlewares = (sagaMiddleware: SagaMiddleware) => {
  arrayOfSagas.forEach(sagaMiddleware.run);
};

export default SagaMiddlewares;
